// react library imports
import { PhoneCall } from 'phosphor-react';
import Moment from 'moment';
import packageJson from '../../../../package.json';

// Importing the necessary CSS file for styling
import './Footer.css';

// data and local component imports and imports from utils
import { data } from './data';
import FooterCard from './FooterCard';

// assets imports
import playStoreLogo from 'Assets/Image/logo/google-play-store.svg';
import appleStoreLogo from 'Assets/Image/logo/apple-store.svg';

const Footer = () => {
  // define year using moment
  const year = Moment(new Date()).format("YYYY")
  const version = packageJson.version;

  // Function to handle Play Store button click and redirect to the specified URL
  const handlePlayStore = (url) => {
    window.open(url)
  }
  return (
    <div>
      <footer className='footer_container padding_container'>
        <section className='footer_container_item mues_white'>
          <section className='mues_info_section'>
            <div className='mues_column_space_between mues_row_gap_8
            mues_info_container'>
              <img src={data.mues_tech_logo} alt="mues-tech-logo" loading='lazy' />
              <p className='mues_font_weight_400'>{data.description}</p>
              <div className='mues_row_flex mues_column_gap_8'>
                <button className='btn mues_row_center' onClick={() => handlePlayStore(data.ios_store_url)}>
                  <img src={appleStoreLogo} alt='apple-store-logo'
                    loading='lazy' />
                  <div className="footer_button_content">
                    <h5 className="mues_font_weight_400">Download on the</h5>
                    <h3 className="mues_font_weight_500">App Store</h3>
                  </div>
                </button>
                <button className='btn mues_row_center' onClick={() => handlePlayStore(data.play_store_url)}>
                  <img src={playStoreLogo} alt='google-play-store-logo'
                    loading='lazy' />
                  <div className="footer_button_content">
                    <h5 className="mues_font_weight_400">GET IT ON</h5>
                    <h3 className="mues_font_weight_500">Google Play</h3>
                  </div>
                </button>
              </div>
            </div>
            <div className='mues_footer_divider' />
            <div>
              <h6 className='mues_font_weight_600'>{data.contact.title}</h6>
              <p className='mues_font_weight_400'>{data.contact.description}</p>
            </div>
            <div className='mues_row_flex mues_column_gap_8'
              data-testid="mues_footer_00">
              <PhoneCall className='mues_wrapper_icon mues_white' weight='fill'/>
              <p className='mues_font_weight_600'>Call</p>
              <p className='mues_font_weight_600'>{data.contact.call}</p>
            </div>
          </section>
          <section className='mues_navigation_section mues_column_space_between
          mues_row_gap_16' data-testid="mues_footer_01">
            <div className='mues_row_space_between mues_navigation_item'
            data-testid="mues_footer_02">
              <FooterCard title={data.company.title}
              list={data.company.list}/>
              <FooterCard title={data.help_and_support.title}
              list={data.help_and_support.list}/>
            </div>
            <div className='mues_row_space_between mues_navigation_item'
            data-testid="mues_footer_03">
              <FooterCard title={data.resources.title}
              list={data.resources.list}/>
              <FooterCard title={data.mues_network.title}
              list={data.mues_network.list}/>
            </div>
          </section>
        </section>
        <div className='mues_column_space_between mues_row_gap_16 mues_white footer_product_container'>
          <h6 className='mues_font_weight_600'>{data.mues_product.title}</h6>
          <div className='mues_footer_product_list'>
            {data.mues_product.mues_product_list.map(item=>(
              <div className='mues_footer_product_logo_container mues_pointer' key={item.id}
              onClick={()=>handlePlayStore(item.play_store_url)}>
                <img src={item.logo} alt="logo" />
              </div>
            ))}
          </div>
        </div>
      </footer>
      <div className='padding_container footer_copy_right_container
      mues_row_space_between'>
        <p className='mues_green mues_font_weight_400'>&copy;{year} {data.copyright}</p>
        <p className='mues_white'>mues-tech version {version}</p>
      </div>
    </div>
  )
}

export default Footer;
